// 9fbef606107a605d69c0edbcd8029e5d
const ADDEDTOBAG_CONSTANTS = {
  SET_ISPLCCICFIRED: 'SET_ISPLCCICFIRED',
  FROM_PAGE_CART: 'cart',
  SET_UNAVAILABLE_PRODUCT_IDS: 'SET_UNAVAILABLE_PRODUCT_IDS',
  ADD_TO_CART_ECOM: 'ADD_TO_CART_ECOM',
  ADD_TO_CART_ECOM_NEW: 'ADD_TO_CART_ECOM_NEW',
  ADD_TO_CART_ECOM_NEW_ATB_LOADED: 'ADD_TO_CART_ECOM_NEW_ATB_LOADED',
  ADD_MULTIPLE_ITEMS_CART_ECOM: 'ADD_MULTIPLE_ITEMS_CART_ECOM',
  ADD_MULTIPLE_ITEMS_CART_ECOM_NEW: 'ADD_MULTIPLE_ITEMS_CART_ECOM_NEW',
  ADD_MULTIPLE_ITEMS_CART_ECOM_COUNT: 'ADD_MULTIPLE_ITEMS_CART_ECOM_COUNT',
  ADD_TO_CART_BOPIS: 'ADD_TO_CART_BOPIS',
  SET_ADDED_TO_BAG: 'SET_ADDED_TO_BAG',
  OPEN_ADDED_TO_BAG: 'OPEN_ADDED_TO_BAG',
  OPEN_ADDED_TO_BAG_MINIMAL: 'OPEN_ADDED_TO_BAG_MINIMAL',
  CLOSE_ADDED_TO_BAG: 'CLOSE_ADDED_TO_BAG',
  SET_ADDED_TO_BAG_ERROR: 'SET_ADDED_TO_BAG_ERROR',
  SET_ADDED_TO_PICKUP_ERROR: 'SET_ADDED_TO_PICKUP_ERROR',
  SET_ADDED_TO_CART_MODAL_ERROR: 'SET_ADDED_TO_CART_MODAL_ERROR',
  CLEAR_ADDED_TO_CART_MODAL_ERROR: 'CLEAR_ADDED_TO_CART_MODAL_ERROR',
  BAG_PAGE: 'BagPage',
  CLEAR_ADD_TO_BAG_ERROR_STATE: 'CLEAR_ADD_TO_BAG_ERROR_STATE',
  CLEAR_ADD_TO_PICKUP_ERROR_STATE: 'CLEAR_ADD_TO_PICKUP_ERROR_STATE',
  CLEAR_ADD_TO_BAG_MULTIPLE_ITEMS_ERROR_STATE: 'CLEAR_ADD_TO_BAG_MULTIPLE_ITEMS_ERROR_STATE',
  SET_ADDED_TO_BAG_MULTIPLE_ITEMS_ERROR: 'SET_ADDED_TO_BAG_MULTIPLE_ITEMS_ERROR',
  SET_ADDED_TO_BAG_OUTFIT_ITEMS_ERROR: 'SET_ADDED_TO_BAG_OUTFIT_ITEMS_ERROR',
  SET_ADDED_TO_BAG_BTN_LOADER: 'SET_ADDED_TO_BAG_BTN_LOADER',
  SET_ADDED_TO_BAG_BUTTON: 'SET_ADDED_TO_BAG_BUTTON',
  SET_OUTFIT_CAROUSEL_BUTTON: 'SET_OUTFIT_CAROUSEL_BUTTON',
  ADDED_TO_BAG_MSG: 'ADDED_TO_BAG_MSG',
  SIZE_SELECT_MSG_SHOW: 'SIZE_SELECT_MSG_SHOW',
  BRIERLEY: 'BRIERLEY',
  LOYALTY: 'LOYALTY',
  NA: 'NA',
  SET_LOYALTY_AB_TEST: 'SET_LOYALTY_AB_TEST',
  SET_MULTIPCAK_PRODUCT_TYPE: 'SET_MULTIPCAK_PRODUCT_TYPE',
  SET_STICKY_FOOTER: 'SET_STICKY_FOOTER',
  GA_ANAYTICS: {
    PDP_MULTIPACK: 'Mpack Pdp|Mpack',
    PDP_SINGLE: 'Spack Pdp|Mpack',
    SEARCH_PDP_MPACK: 'Search Pdp|Mpack',
    SLP_MPACK: 'SLP|Mpack',
    PLP_MPACK: 'Plp|Mpack',
    PACK: 'pack',
  },
  GA_ANAYTICS_APP: {
    PDP_MULTIPACK: 'Mpack Pdp-Mpack',
    PDP_SINGLE: 'Spack Pdp-Mpack',
    SEARCH_PDP_MPACK: 'Search Pdp-Mpack',
    SLP_MPACK: 'SLP-Mpack',
    PLP_MPACK: 'Plp-Mpack',
    PACK: 'pack',
  },
  SET_PDP_LARGE_IMAGE_URL: 'SET_PDP_LARGE_IMAGE_URL',
  SET_IS_MULTIPCAK_ITEM: 'SET_IS_MULTIPCAK_ITEM',
  SET_BAG_ANALYTICS: 'SET_BAG_ANALYTICS',
  GHOST_LOADER_DELAY: 800,
  API_CANT_RESOLVE_FFMCENTER: '_API_CANT_RESOLVE_FFMCENTER',
  API_CANT_RESOLVE_FFMCENTER_SHORT: '_API_CANT_RESOLVE_FFMCENTER_SHORT',
  BOSS_BOPIS_QUANTITY_UNAVAILABLE: '_BOSS_BOPIS_QUANTITY_UNAVAILABLE',
  PRODUCT_QUANTITY_UNAVAILABLE: '_PRODUCT_QUANTITY_UNAVAILABLE',
  ECOM_QUANTITY_UNAVAILABLE: '_ECOM_QUANTITY_UNAVAILABLE',
  API_CANT_RESOLVE_FFMCENTER_OOS: '_API_CANT_RESOLVE_FFMCENTER_OOS',
  API_CANT_RESOLVE_FFMCENTER_PARTIAL_INSTOCK_MSG1:
    '_API_CANT_RESOLVE_FFMCENTER_PARTIAL_INSTOCK_MSG1',
  API_CANT_RESOLVE_FFMCENTER_PARTIAL_INSTOCK_MSG2:
    '_API_CANT_RESOLVE_FFMCENTER_PARTIAL_INSTOCK_MSG2',
  FBT_STATUS: 'FBT_STATUS',
  IS_FBT_COMPLETE: 'IS_FBT_COMPLETE',
  SET_FBT_FLAG: 'SET_FBT_FLAG',
  SET_ADDED_TO_FBT_ERROR: 'SET_ADDED_TO_FBT_ERROR',
  CLEAR_ADD_TO_FBT_ERROR_STATE: 'CLEAR_ADD_TO_FBT_ERROR_STATE',
  UPDATE_MINIBAG_CLOSE_STATUS: 'UPDATE_MINIBAG_CLOSE_STATUS',
  UPDATE_ADD_TO_BAG_IN_PROGRESS: 'UPDATE_ADD_TO_BAG_IN_PROGRESS',
  SAVE_USER_BROWSE_HISTORY: 'SAVE_USER_BROWSE_HISTORY',
  ADDED_TO_BAG_METHOD: 'ADDED_TO_BAG_METHOD',
  ADDED_TO_BAG_PAGINATION: 'ADDED_TO_BAG_PAGINATION',
  SET_ISEXPRESSAFTERPAY_DONE: 'SET_ISEXPRESSAFTERPAY_DONE',
  ADDED_TO_BAG_FROM_OUTFIT_EXP: 'New Outfit Experience',
  ADDED_TO_BAG_FROM_STORE_MODAL: 'Store Modal',
  ADOBE_ANALYTICS: {
    PDP_MULTIPACK: 'Mpack Pdp|Mpack',
    PDP_SINGLE: 'Spack Pdp|Mpack',
    SEARCH_PDP_MPACK: 'Search Pdp|Mpack',
    SLP_MPACK: 'SLP|Mpack',
    PLP_MPACK: 'Plp|Mpack',
    PACK: 'pack',
    PRICING_ON_SALE: 'on sale',
    PRICING_FULL_PRICE: 'full price',
  },
  ADOBE_ANALYTICS_APP: {
    PDP_MULTIPACK: 'Mpack Pdp-Mpack',
    PDP_SINGLE: 'Spack Pdp-Mpack',
    SEARCH_PDP_MPACK: 'Search Pdp-Mpack',
    SLP_MPACK: 'SLP-Mpack',
    PLP_MPACK: 'Plp-Mpack',
    PACK: 'pack',
    PRICING_ON_SALE: 'on sale',
    PRICING_FULL_PRICE: 'full price',
  },
  DEPARTMENT_CAROUSEL_PRODUCTS: 'DEPARTMENT_CAROUSEL_PRODUCTS',
  SET_LOYALTY_ORDER_ITEMS: 'SET_LOYALTY_ORDER_ITEMS',
  SET_OFFER_PRICE_LOADING_STATE: 'SET_OFFER_PRICE_LOADING_STATE',
  SET_INVENTORY_UNAVAILABLE: 'SET_INVENTORY_UNAVAILABLE',
};

export default ADDEDTOBAG_CONSTANTS;
